<mb-form-field appearance='light' class='sorting'>
  <label mb-form-field-label for='order'>Ordenar por</label>
  <select mb-form-field-input id='order' [(ngModel)]='sortingValue' (change)='applyChange()' [disabled]='disabled'>
    <option value="recommended" i18n="@@sorting__recommended">Más Vendidos</option>
     <option value="price-ASC" i18n="@@sorting__price-ASC">Precio más bajo</option>
     <option value="price-DESC" i18n="@@sorting__price-DESC">Precio más alto</option>
    <option value="stars-DESC" i18n="@@sorting__stars-DESC">Más estrellas</option>
     <option value="stars-ASC" i18n="@@sorting__stars-ASC">Menos estrellas</option>
     <option value="rating-DESC" i18n="@@sorting__rating-DESC">Mejor Puntuación</option>
  </select>
</mb-form-field>
